module.exports = __webpack_public_path__ + "static/media/waking_up.2e01763a.png";